import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import theme from 'assets/theme'
import { Trans } from 'react-i18next'
import { QuoteStatus } from './QuoteDetails.types'

export interface QuoteAlertProps {
  quoteStatus: QuoteStatus,
  quoteSnackbarOpen: boolean,
  handleSnackbarClose: () => void,
}

const QuoteAlert = ({ quoteStatus, quoteSnackbarOpen, handleSnackbarClose }: QuoteAlertProps) => {

  return (<Snackbar
    open={quoteSnackbarOpen}
    onClose={handleSnackbarClose}
  >
    <Alert
      onClose={handleSnackbarClose}
      severity={quoteStatus === QuoteStatus.SUBMITTED ? 'success' : 'warning'}
      variant="filled"
      sx={{
        width: '50%',
        backgroundColor: quoteStatus === QuoteStatus.SUBMITTED ? theme.palette.success.main : theme.palette.warning.light,
        color: quoteStatus === QuoteStatus.SUBMITTED ? theme.palette.success.contrastText : theme.palette.primary.main,
      }}
      iconMapping={{
        success: <CheckCircleOutlineIcon fontSize="inherit" color="success" />,
      }}
    >
      {quoteStatus === QuoteStatus.SUBMITTED ?
        <Trans
          i18nKey={'screens.cs.carrier_quotes.quote_accepted'}
          components={{ strong: <strong /> }} color={theme.palette.success.contrastText}>
        </Trans> :
        <Trans
          i18nKey={'screens.cs.carrier_quotes.quote_rejected'}
          components={{ strong: <strong /> }}>
        </Trans>
      }
    </Alert>
  </Snackbar>)
}

export default QuoteAlert

